export const NAV_MENUS = {
  services: 'services',
  industries: 'industries',
  clients: 'clients',
  insights: 'insights',
};

/**
 * Create Twitter page url from twitterHandle
 *
 * @param {String} id - menu id
 * @param {String} config - app config
 *
 * @return {Object} menu config
 */
export const navMenuConfig = (id, config) => {
  return config.nav.configNav.find(navConfig => navConfig.id === id);
};
